var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertaPreto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.692,
    height: 24,
    viewBox: "0 0 19.692 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1",
    width: 19.692,
    height: 24,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.692,
    height: 24,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#rect-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#rect-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillRule: "evenodd",
    d: "M17.23098755 16.61499023v-6.15298461c0-3.77801514-2.00598145-6.9420166-5.53799439-7.77801514V1.8460083C11.69299316.82647705 10.86651611 0 9.84698486 0 8.82748413 0 8.00100708.82647705 8.00100708 1.8460083v.83700562c-3.52001953.8369751-5.53799438 3.98797607-5.53799438 7.77798462v6.1539917L0 19.07699584v1.23101807h19.69198608v-1.23101807l-2.46099853-2.46200562zM4.92300415 17.8460083h9.8460083v-7.38400268c0-3.05200196-1.8580017-5.53799439-4.92300415-5.53799439-3.06500244 0-4.92300415 2.48599243-4.92300415 5.53799439v7.38400268zM9.8460083 24c1.35812378-.00384521 2.4581604-1.10388184 2.46200562-2.46200562H7.38500977C7.38885498 22.89572144 8.48828125 23.99560547 9.8460083 24z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertaPreto);
export default __webpack_public_path__ + "static/media/alerta_preto.c5facc8bc737825a1950616042617148.svg";
export { ForwardRef as ReactComponent };